import { render, staticRenderFns } from "./SettlementStatusCounters.vue?vue&type=template&id=af56ada6&scoped=true&"
import script from "./SettlementStatusCounters.vue?vue&type=script&lang=js&"
export * from "./SettlementStatusCounters.vue?vue&type=script&lang=js&"
import style0 from "./SettlementStatusCounters.vue?vue&type=style&index=0&id=af56ada6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af56ada6",
  null
  
)

export default component.exports